import React from 'react'
import TodoListItem from 'components/containers/task/TodoListItem'
import ArrowIcon from 'images/right_arrow_icon-8x14.png'
import {
  ListSection,
  SingleSection,
  ListHeader,
  HeaderLeft,
  TitleTxt,
  ArrowIconWrapper,
  HeaderRight,
  ListBody,
} from './style'

import {
  GroupSection,
  GroupHeader,
  TodolistGroupBlock,
} from 'components/presenters/task/TodolistGroup'
import { TodoItem, ChallengeStartButton, ToolTip } from 'components/presenters/task/TodoItem'
import SplitterBar from 'components/presenters/common/SplitterBar'

export default function TodoListGroup({
  listInfo,
  setModalVisible,
  setModalDataList,
  setCurrTask,
  currTaskNo,
  onTriggerSelectImg,
  relation,
  onEditTaskResult,
  onDeleteTask,
  onDeleteRoutine,
  onDeleteTaskResult,
  onError,
  disableEditTask = false,
  onShareTaskResult,
  onChallengeStartClick,
}) {
  let listDom = []
  if (['group', 'campaign'].includes(listInfo['type'])) {
    let taskList = []
    let headerLink = ''
    let key = null

    if (listInfo['type'] === 'campaign') {
      if (Array.isArray(listInfo['tasks'])) {
        for (let i = 0; i < listInfo['tasks'].length; ++i) {
          let targetTask = listInfo['tasks'][i]
          targetTask['campaign_no'] = listInfo['no']
          taskList.push(targetTask)
        }
      }
      headerLink = `/campaign/${listInfo['no']}`
      key = `list-section-campaign-key-${listInfo['no']}`
    } else if (listInfo['type'] === 'group') {
      for (let i = 0; i < listInfo['projects'].length; ++i) {
        if (Array.isArray(listInfo['projects'][i]['tasks'])) {
          for (let j = 0; j < listInfo['projects'][i]['tasks'].length; ++j) {
            let targetTask = listInfo['projects'][i]['tasks'][j]
            targetTask['group_no'] = listInfo['no']
            targetTask['project_no'] = listInfo['projects'][i]['no']
            taskList.push(targetTask)
          }
        }
      }
      headerLink = `/group/${listInfo['no']}`
      key = `list-section-group-key-${listInfo['no']}`
    }

    listDom.push(
      <ListSection key={key}>
        <ListHeader to={headerLink}>
          <HeaderLeft>
            <TitleTxt>{listInfo['title']}</TitleTxt>
          </HeaderLeft>
          <HeaderRight>
            <ArrowIconWrapper>
              <img src={ArrowIcon} />
            </ArrowIconWrapper>
          </HeaderRight>
        </ListHeader>
        <ListBody>
          {taskList.map((value) => {
            let linkPath = null
            if (value['type'] === 'group_project') {
              linkPath = `/group/${value['group_no']}/project/${value['project_no']}`
            } else if (value['type'] === 'campaign') {
              linkPath = `/campaign/${value['campaign_no']}`
            }
            let modalDataList = []
            if (Array.isArray(value['proof']) && value['proof'].length > 0) {
              // modalDataList.push({
              //   type: 'callback',
              //   callback: () => onShareTaskResult(value),
              //   style: { color: '#000000' },
              //   text: '공유하기',
              // })
              modalDataList.push({
                type: 'callback',
                callback: onEditTaskResult,
                callbackParam: { task_no: value['no'] },
                style: { color: '#000000' },
                text: '게시물 수정',
              })
              modalDataList.push({
                type: 'callback',
                callback: onDeleteTaskResult,
                callbackParam: { task_no: value['no'] },
                style: { color: '#DE0000' },
                text: '게시물 삭제',
              })
            }

            return (
              <TodoListItem
                key={`todolist-item-no-${value['no']}`}
                style={{
                  paddingTop: 'calc(100vw*(12.5/375))',
                  paddingBottom: 'calc(100vw*(12.5/375))',
                }}
                task={value}
                linkPath={linkPath}
                setModalVisible={setModalVisible}
                setModalDataList={setModalDataList}
                onClickUploadBtn={() => {
                  currTaskNo.current = value
                  setCurrTask(value)
                  onTriggerSelectImg()
                }}
                onOptionBtnClick={
                  modalDataList.length > 0
                    ? () => {
                        setModalDataList(modalDataList)
                        setModalVisible(true)
                      }
                    : null
                }
                relation={relation}
                disableEditTask={disableEditTask}
                onError={(e) => {
                  if (onError) {
                    onError(e)
                  }
                }}
              />
            )
          })}
        </ListBody>
      </ListSection>,
    )
  } else if (['normal', 'routine', 'onboarding'].includes(listInfo['type'])) {
    let key = `list-section-task-key-${listInfo['no']}`
    let taskInfo = listInfo
    let modalDataList = []
    if (listInfo['type'] === 'routine') {
      let routineNo = listInfo['no']
      if (!listInfo['task']) {
        return <></>
      }
      taskInfo = listInfo['task']
      taskInfo['routine_no'] = routineNo
      /*
	{
				type : "callback",
				callback : ()=>{history.push(`/routine/${routineNo}/update`)},
				style: {color: '#000000'},
				text: "루틴 수정"
			},
			{
				type : "callback",
				callback : onDeleteRoutine,
				callbackParam: {routine_no:routineNo},
				style: {color: '#DE0000'},
				text: "루틴 삭제"
			}
			*/
      modalDataList = []
    } else if (listInfo['type'] === 'normal') {
      modalDataList = [
        {
          type: 'callback',
          callback: onDeleteTask,
          callbackParam: { task_no: taskInfo['no'] },
          style: { color: '#DE0000' },
          text: '투두리스트 삭제',
        },
      ]
    }

    if (Array.isArray(taskInfo['proof']) && taskInfo['proof'].length > 0) {
      modalDataList.push({
        type: 'callback',
        callback: onEditTaskResult,
        callbackParam: { task_no: taskInfo['no'] },
        style: { color: '#000000' },
        text: '게시물 수정',
      })

      modalDataList.push({
        type: 'callback',
        callback: onDeleteTaskResult,
        callbackParam: { task_no: taskInfo['no'] },
        style: { color: '#DE0000' },
        text: '게시물 삭제',
      })
    }

    listDom.push(
      <SingleSection key={key}>
        <TodoListItem
          task={taskInfo}
          setModalVisible={setModalVisible}
          setModalDataList={setModalDataList}
          onClickUploadBtn={() => {
            currTaskNo.current = taskInfo
            setCurrTask(taskInfo)
            onTriggerSelectImg(true)
          }}
          onOptionBtnClick={
            modalDataList.length > 0
              ? () => {
                  setModalDataList(modalDataList)
                  setModalVisible(true)
                }
              : null
          }
          relation={relation}
          disableEditTask={disableEditTask}
          onError={(e) => {
            if (onError) {
              onError(e)
            }
          }}
        />
      </SingleSection>,
    )
  } else if (['product_challenge'].includes(listInfo.type)) {
    listDom.push(
      <GroupSection key={`list-section-product-challenge-${listInfo['no']}`}>
        <GroupHeader
          isChallenge={true}
          title={listInfo.title}
          linkPath={`/motishop/product/${listInfo.product_no}`}
        />
        <SplitterBar color={'#E5E5E5'} />
        <TodolistGroupBlock>
          {listInfo?.tasks?.length > 0 ? (
            listInfo?.tasks.map((task) => (
              <TodoItem
                key={`task-no-${task.no}`}
                task={task}
                relation={relation}
                onClickUploadBtn={() => {
                  currTaskNo.current = task
                  setCurrTask(task)
                  onTriggerSelectImg(true)
                }}
                onError={(e) => {
                  if (onError) onError(e)
                }}
                disableEditTask={disableEditTask}
                onOptionBtnClick={
                  task?.proof
                    ? () => {
                        setModalVisible(true)
                        setModalDataList([
                          {
                            type: 'callback',
                            callback: () => onEditTaskResult({ task_no: task.no }),
                            style: { color: '#000000' },
                            text: '게시물 수정',
                          },
                          {
                            type: 'callback',
                            callback: () =>
                              onDeleteTaskResult({
                                task_no: task.no,
                              }),
                            style: { color: '#DE0000' },
                            text: '게시물 삭제',
                          },
                        ])
                      }
                    : null
                }
              />
            ))
          ) : (
            <ChallengeStartButton
              onChallengeStartClick={() => onChallengeStartClick(relation, listInfo?.attendee)}
              toolTip={<ToolTip />}
            />
          )}
        </TodolistGroupBlock>
      </GroupSection>,
    )
  }

  return <div>{listDom}</div>
}
